import { useContext } from "react";
import { I18nContext } from "#/context";
export const useI18nContext = () => {
  return useContext(I18nContext);
};